/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NonConformanceModel } from '../../models/non-conformance-model';

export interface GetNonConformance$Params {
  nonConformanceId: number;
}

export function getNonConformance(http: HttpClient, rootUrl: string, params: GetNonConformance$Params, context?: HttpContext): Observable<StrictHttpResponse<NonConformanceModel>> {
  const rb = new RequestBuilder(rootUrl, getNonConformance.PATH, 'get');
  if (params) {
    rb.path('nonConformanceId', params.nonConformanceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NonConformanceModel>;
    })
  );
}

getNonConformance.PATH = '/api/v1/QualityHistory/{nonConformanceId}/GetNonConformance';
